import React from 'react';
import { useController } from 'react-hook-form';
import { IUploadFileFieldProps } from '../types';
import UploadFile from '../../uploadFile';
import { DEFAULT_REQUIRED_ERROR } from '../index';
import getFieldError from '../utils/getFieldError';

const UploadFileField: React.FC<IUploadFileFieldProps> = props => {
	const {
		field: { fieldName, onChange, isRequired, value, defaultValue, hotReload, errorMessage, ...rest },
		formHook: { control, setValue },
	} = props;
	const {
		field,
		formState: { errors },
	} = useController({
		name: fieldName,
		defaultValue,
		control,
		rules: {
			required: isRequired ? errorMessage || DEFAULT_REQUIRED_ERROR : false,
		},
	});
	const message = getFieldError(fieldName, errors);

	const registrationWithUserProps = {
		...field,
		onChange: (fieldValue: any[]): void => {
			if (onChange) onChange(fieldValue);
			field.onChange(fieldValue);
		},
	};

	React.useEffect(() => {
		if (!Array.isArray(value)) return;
		setValue(fieldName, value);
	}, [fieldName, value, setValue]);

	React.useEffect(() => {
		if (!Array.isArray(defaultValue) || !hotReload) return;
		setValue(fieldName, defaultValue);
	}, [fieldName, defaultValue, hotReload, setValue]);

	return <UploadFile {...rest} {...registrationWithUserProps} isInvalid={!!message} isRequired={isRequired} errorMessage={message} />;
};

export default React.memo(UploadFileField);
